import { z } from 'zod';

const TematicaUiSchema = z.object({
  id: z.number(),
  nombre: z.string()
}).nullable().optional();

export const ObtenerUsuarioUiSchema = z.object({
  id: z.number(),
  nombreCompleto: z.string(),
  nombre: z.string(),
  apellido: z.string(),
  email: z.string(),
  tematica: TematicaUiSchema
});

export type ObtenerUsuarioUi = z.infer<typeof ObtenerUsuarioUiSchema>; 